import React, { useState } from "react";
import { useStores } from "../../../use-stores";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import FormSmallTextField from "../../components/common/form/FormTextField";
import { useNotification } from "../../../utils/NotificationsContext";

interface OtpProps {
  email: string;
  password: string;
  open: boolean;
  onCancel: () => void;
}

const Otp: React.FC<OtpProps> = ({ email, password, open, onCancel }) => {
  const { userStore } = useStores();
  const [otp, setOtp] = useState("");
  const [, setLoading] = useState(false);
  const { showError } = useNotification();

  const handleInputChange = (id?: string, otp?: string) => {
    setOtp(otp!);
  };

  async function verifyOtp() {
    try {
      setLoading(true);
      const user = await userStore.verifyLoginOtp(email, password, otp);
      if (user !== undefined) {
        setLoading(false);
        if (user?.token) {
          setLoading(false);
          window.location.reload();
        }
      } else {
        setLoading(false);
        showError("Error", "Invalid OTP");
      }
    } catch (err) {
      setLoading(false);
      showError("Error", "Login failed. Failed to verify OTP.");
    }
  }

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCancel()
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px",
            marginBottom: "11px",
          },
        },
      }}
    >
      <DialogTitle>Enter OTP</DialogTitle>
      <DialogContent style={{ paddingTop: "5px" }}>
        <FormSmallTextField
          id="Enter OTP"
          label="OTP here *"
          variant="outlined"
          fontSize="14px"
          onChange={handleInputChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={verifyOtp} color="primary">
          Verify
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Otp;
